import { Injectable, Type } from '@angular/core';
import { HomehuntComponent } from 'src/app/_shared/component/company-footer/component/homehunt/homehunt.component';
import { RubyporchComponent } from 'src/app/_shared/component/company-footer/component/rubyporch/rubyporch.component';
import { DefaultComponent } from './component/default/default.component';
import { HomeriseComponent } from './component/homerise/homerise.component';

@Injectable({
  providedIn: 'root',
})
export class CompanyFooterService {
  constructor() { }
  getCompanyComponent(aliasName): {
    data: any;
    component: Type<any>;
  } {
    switch (aliasName) {
      case 'homehunt':
        return { data: null, component: HomehuntComponent };
  
      case 'rubyporch':
        return { data: null, component: RubyporchComponent };
  
      case 'homerise':
        return { data: null, component: HomeriseComponent };
  
      default:
        return { data: null, component: DefaultComponent };
    }
  }
}
